import { ContentByPropertyMap } from '../../data/sanity/types';
import { TOP_SEARCHES_LIMIT } from './DestinationSearch.constants';
import {
  DestinationOptionType,
  type LocalStorageResult,
  type Option,
} from './DestinationSearch.types';

export const checkForHumor = (inputText: string): boolean => {
  switch (inputText.toLowerCase().trim()) {
    case 'gravity falls':
      import('./easter-eggs/gravity.easter-egg.js');
      return true;
    case 'make it rain':
      import('./easter-eggs/money-falling.easter-egg.js');
      return true;
    case 'make it snow':
      import('./easter-eggs/snow-falling.easter-egg.js');
      return true;
  }

  return false;
};

export const topFourResultsByCategory = (
  suggestions: DestinationOptionType[]
) => {
  const citySuggestions = suggestions
    .filter((item) => item.categoryType === 'PolygonCityZone')
    .slice(0, 4);

  const otherSuggestions = suggestions
    .filter((item) => item.categoryType !== 'PolygonCityZone')
    .slice(0, 4);

  return citySuggestions.concat(otherSuggestions);
};

export const getOptionAddedToTopLastSearches = (
  option: Option,
  storedValue?: LocalStorageResult[]
): LocalStorageResult[] => {
  const newResult = {
    option,
    referredAt: new Date().toISOString(),
  };

  const filteredResults = storedValue
    ? getOptionRemovedFromTopLastSearches(option.label, storedValue)
    : [];

  return [newResult, ...filteredResults].slice(0, TOP_SEARCHES_LIMIT);
};

export const getOptionRemovedFromTopLastSearches = (
  label: string,
  storedValue: LocalStorageResult[]
): LocalStorageResult[] => {
  return storedValue.filter((res) => res.option.label !== label);
};

export const isValidLocalStorageValue = (data: unknown) => {
  return (
    Array.isArray(data) &&
    data.every(
      (item) => item && typeof item === 'object' && !Array.isArray(item)
    )
  );
};

export const mapOptionsGroupedByCategoryLabel = (
  options: Option[]
): ContentByPropertyMap<DestinationOptionType, 'categoryType'> => {
  return options.reduce(
    (acc, option) => {
      if (!acc['RecentSearches']) {
        acc['RecentSearches'] = [];
      }

      acc['RecentSearches'].push({
        ...option,
        categoryType: 'RecentSearches',
      });

      return acc;
    },
    {} as ContentByPropertyMap<DestinationOptionType, 'categoryType'>
  );
};

export const getDestinationIdentifier = (option: Option): string => {
  if (option.polygonId) {
    return `polygon-id:${option.polygonId}`;
  }

  if (option?.hotel?.hotelCode) {
    return `hotel-code:${option.hotel.hotelCode}`;
  }

  return option.label;
};
